<template>
    <div>
          <!--  Modal PIN-->
        <b-modal id="change-pin"
            centered
            title="Change Account Verification Password"
            @ok="updatePin"
            @cancel="clearDetails"
            :ok-variant="controls.btnColor"
            :ok-disabled="disableOk"
            ok-title="Change Password"
            cancel-variant="link">
            <form>
                <div class="row">
                    <div class="col-sm-12 col-lg-8 offset-lg-2">
                        <!-- New PIN -->
                        <div class="form-group">
                            <label for="NewPin">Enter new account verification password</label>
                            <input type="password"
                                name="newPin"
                                v-model="formModels.newPin"
                                v-on:input="$v.formModels.newPin.$touch"
                                class="form-control"
                                autocomplete="off"
                                :class="{'is-invalid': $v.formModels.newPin.$error, 'is-valid': $v.formModels.newPin.$dirty && !$v.formModels.newPin.$invalid}"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import Vuelidate from 'vuelidate';
import { required, sameAs, minLength} from 'vuelidate/lib/validators';

export default {
    data(){
        return{
            controls:{
                btnColor:'success',
            },
            formModels:{
                newPin:'',
                reEnterNewPin:'',
            }
        }
    },
    validations:{
        formModels:{
            newPin:{
                required
            },
        }
    },
    computed:{
        disableOk() {
            if(!this.$v.$invalid) {
                this.controls.btnColor = 'success'
                return false;
            } else {
                this.controls.btnColor = 'light'
                return true;
            }
        },
    },
    methods:{
        updatePin(){
            this.$emit('pin:update', this.formModels.newPin)
            this.clearDetails()
        },
        clearDetails() {
            this.formModels.newPin = '';
            this.formModels.reEnterNewPin = '';
            this.$v.$reset(); //reset vuelidate
        },
        showFeedback ({suggestions, warning}) {
            //console.log('', suggestions)
            //console.log('', warning)
        },
        showScore (score) {
            //console.log('', score)
        },
    }

}
</script>

<style>

</style>
